module.exports = __webpack_public_path__ + "img/1-1.ba58a02d.png";